<template>
	<div v-if="good_detail">
		<van-sticky>
			<div class="rcst_sc">
				<div @click="backPrev()" class="rcst_sc_drop">
					<div class="rcst_sc_drop_left">
						<img src="../demo1/source/back.png" alt="" />
					</div>
				</div>
				<div class="rcst_sc_drop_center">创建订单</div>
			</div>
		</van-sticky>
		
		<div class="scpz_head ">
			<div class="scpz_head_title">{{good_detail.venueName}}</div>
			<div class="scpz_head_tag">{{good_detail.goodsName}}</div>
		</div>
		<div class="scoi_out">
			<div class="scoi">
				<div class="scoi_title">预约信息</div>
				<div class="scoi_item">
					<div class="scoi_item_left">预约日期</div>
					<div class="scoi_item_right scoi_item_right_orange" style="background-image: none;">
						{{book_date}}
					</div>
				</div>
				<div class="scoi_item">
					<div class="scoi_item_left">预约时间</div>
					<div class="scoi_item_right scoi_item_right_orange" style="background-image: none;">
						{{book_time}}
					</div>
				</div>
				<div class="scoi_item">
					<div class="scoi_item_left">预约人</div>
					<div class="scoi_item_right" style="background-image: none;">
						<input v-model="book_name" type="text" placeholder="请输入姓名" maxlength="20" style="text-align: right;" />
					</div>
				</div>
				<div class="scoi_item">
					<div class="scoi_item_left">手机号</div>
					<div class="scoi_item_right" style="background-image: none;">
						<input v-model="book_phone" type="tel" placeholder="请输入手机号" maxlength="11" style="text-align: right;" />
					</div>
				</div>
			</div>
		</div>

		<div class="scop_out">

			<div class="scop">
				<div class="scop_block">
					<div class="scop_block_title">权益兑换</div>
					<div v-if="false" class="scop_block_item">
						<div class="scop_block_item_left">单价</div>
						<div class="scop_block_item_right">
							¥{{good_detail.price}}
						</div>
					</div>
					<div v-if="false" class="scop_block_item">
						<div class="scop_block_item_left">数量</div>
						<div class="scop_block_item_right">1</div>
					</div>
					<div class="scop_block_item">
						<div class="scop_block_item_left">权益券码</div>
						<div class="scop_block_item_right">
							<input v-model="discount_code" placeholder="请输入权益券码"style="text-align: right;border: none;outline: none;" />
						</div>
					</div>
					<!-- <div class="scop_block_item">
						<div class="scop_block_item_left"></div>
						<div class="scop_block_item_right">
							合计：<div class="scop_block_item_right_orange" style="color: #F77F28;">¥{{discount_code.length>0?'0':good_detail.price}}</div>
						</div>
					</div> -->
				</div>
			</div>
			<div class="scop_protol">如需退订,请提前24小时申请</div>
		</div>
		<div class="scoi_bot">
			<div @click="submitOrder()">提交订单</div>
		</div>
	</div>
</template>

<script>
	import {
		futureTimesGroup,
		isPhone
	} from "../../lib/utils.js"
	export default {
		data() {
			return {
				book_date: '',
				book_time:'',
				goodsId: '',
				good_detail:null,
				discount_code:'',
				book_phone:'',
				book_name:''
			}
		},
		mounted() {
			this.$loading('正在加载中...');
			// console.log(this.$route.params.date);
			this.book_date = this.$route.params.date
			this.book_time=this.$route.params.time
			this.goodsId = this.$route.params.goodsId
			this.getDetail()
			
		},
		methods: {
			// 
			getUserInfo(){
				var $this = this
				var param = {}
				var qs = require('qs');
				let url = this.api.userApi.demo1_user_info
				this.axios.post(url, qs.stringify(param))
					.then((res) => {
						// console.log(res)
						$this.$loading.close();
						if(res.data && res.data.userMobile){
							$this.book_phone=res.data.userMobile
						}
					}).catch((error) => {
						$this.$loading.close();
						console.warn(error)
						if(error.code==200105){
							
						}else{
							$this.$toast(error.msg?error.msg:error.message);
						}
					})
			},
			backPrev(){
				this.$router.go(-1)
			},
			getDetail() {
				var $this = this
				var param = {
					goods_id: this.goodsId
				}
				var qs = require('qs');
				let url = this.api.userApi.demo1_getVenueGoodsInfo
				this.axios.post(url, qs.stringify(param))
					.then((res) => {
						// console.log(res)
						$this.good_detail = res.data
						$this.getUserInfo()
					}).catch((error) => {
						$this.$loading.close();
						console.warn(error)
						if(error.code==200105){
							
						}else{
							$this.$toast(error.msg?error.msg:error.message);
						}
					})
			},
			selectSportTypeDate(e) {
				this.date_index = e
			},
			switchRuleType(e) {
				this.rule_type = e
			},
			toSplCreateOrder() {},
			submitOrder(){
				// this.$toast('订单提交成功');
				// demo1_create_order
				if(!this.book_name){
					this.$toast('请输入预约人姓名');
					return
				}
				if(!isPhone(this.book_phone) || this.book_phone.length!=11){
					this.$toast('请输入有效联系方式');
					return
				}
				if(!this.discount_code){
					this.$toast('请输入权益券码');
					return
				}
				this.$loading('正在下单...');
				var $this = this
				var param = {
					goods_id: this.goodsId,
					code:this.discount_code,
					book_name:this.book_name,
					book_mobile:this.book_phone,
					book_day:this.book_date,
					book_time:this.book_time,
				}
				// console.log(param);
				// return
				var qs = require('qs');
				let url = this.api.userApi.demo1_create_order
				this.axios.post(url, qs.stringify(param))
					.then((res) => {
						// console.log(res)
						$this.$loading.close();
						$this.$toast('下单成功');
						setTimeout(()=>{
							$this.$router.push({
								name: 'venue_goods_order'
							})
						},500)
					}).catch((error) => {
						$this.$loading.close();
						if(error.code==200105){
							
						}else{
							$this.$toast(error.msg?error.msg:error.message);
						}
					})
			}
		}
	}
</script>

<style lang="less" scoped="scoped">
	@vm_base: 1/750*100vw;
	
	.rcst_sc {
		width: 100%;
		/* padding: 0 30*@vm_base; */
		padding: 0 30*@vm_base;
		// padding: 0 0 20*@vm_base 0;
		background-color: #fff;
		
		display: flex;
		justify-content: space-between;
		align-items: center;
	
		.rcst_sc_drop {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			width: fit-content;
			
			.rcst_sc_drop_left{
				width: 80*@vm_base;
				height: 80*@vm_base;
				// border: 1*@vm_base solid red;
				display: flex;
				justify-content: flex-start;
				align-items: center;
				img{
					width: 36*@vm_base;
				}
			}
		}
		.rcst_sc_drop_center{
			width: calc(100% - 80*@vm_base);
			height: 80*@vm_base;
			padding-right: 80*@vm_base;
			font-size: 28*@vm_base;
			color: #666666;
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}

	.scpz_head {
		width: 100%;
		background-color: #ffffff;
		padding: 40*@vm_base;

		.scpz_head_title {
			width: 100%;
			font-weight: 600;
			font-size: 36*@vm_base;
			color: #333333;
		}

		.scpz_head_tag {
			width: fit-content;
			font-size: 30*@vm_base;
			height: 50*@vm_base;
			display: flex;
			justify-content: center;
			align-items: center;
			color: #F77F28;
			-webkit-text-stroke: 0px #F77F28;
			border-radius: 8*@vm_base;
			border: 1*@vm_base solid #F77F28;
			padding: 0 20*@vm_base;
			margin-top: 30*@vm_base;
		}
	}

	.scoi_out {
		width: 100%;
		padding: 0 20*@vm_base;

		.scoi {
			background: #FFFFFF;
			border-radius: 16*@vm_base;
			padding: 30*@vm_base;
			margin-top: 20*@vm_base;


			.scoi_title {
				font-weight: 600;
				font-size: 30*@vm_base;
				color: #333333;
				line-height: 1.36;
			}

			.scoi_item {
				width: 100%;
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-top: 30*@vm_base;
				font-size: 28*@vm_base;
			}

			.scoi_item_left {
				color: #666666;
				white-space: nowrap;
			}

			.scoi_item_right {
				color: #333333;
				// padding: 0 30*@vm_base;
				background-image: url(https://526ocvgabaebpth66ic1-1315430534.cos.ap-shanghai.myqcloud.com/healthy_image/20240725_by1a5xaY5hc36DJ.png);
				background-size: 28*@vm_base;
				background-repeat: no-repeat;
				background-position: right center;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				input{
					border: none;
					outline: none;
				}
			}

			.scoi_item_right_orange {
				color: #F77F28;
			}
		}

	}


	.scop_out {
		width: 100%;
		padding: 0 20*@vm_base;
		margin-top: 20*@vm_base;



		.scop {
			width: 100%;
			padding: 30*@vm_base 0;
			background: #FFFFFF;
			border-radius: 16*@vm_base;
		}

		.scop_block {
			padding: 0 20*@vm_base;
		}

		.scop_block_title {
			font-weight: 600;
			font-size: 30*@vm_base;
			color: #333333;
			line-height: 1.36;
		}

		.scop_block_item {
			width: 100%;
			display: flex;
			justify-content: space-between;
			align-items: center;
			font-size: 28*@vm_base;
			margin-top: 30*@vm_base;
		}

		.scop_block_item_left {
			color: #666666;
			line-height: 1.36;
		}

		.scop_block_item_right {
			display: flex;
			justify-content: center;
			align-items: center;
			color: #333333;
			line-height: 1.36;
			// padding-right: 30*@vm_base;
			background-size: 30*@vm_base;
			background-repeat: no-repeat;
			background-position: right center;
			// color: #F77F28;
		}

		.scop_block_item_right_tag {
			min-width: 130*@vm_base;
			width: fit-content;
			white-space: nowrap;
			background: linear-gradient(90deg, #262322 0%, #4A4442 100%);
			border-radius: 8*@vm_base;
			display: flex;
			justify-content: center;
			align-items: center;
			padding: 6*@vm_base 14*@vm_base;
			font-size: 22*@vm_base;
			color: #FFDDB0;
			margin-right: 10*@vm_base;
		}

		.scop_block_item_right_retail {
			font-size: 24*@vm_base;
			color: #999999;
			text-decoration: line-through;
			padding-right: 50*@vm_base;
		}
		.scop_protol{
			color: #F77F28;
			padding: 30*@vm_base 0;
		}
	}

	.scoi_bot{
		position: fixed;
		bottom: 0;
		left: 0;
		width: 100%;
		padding: 40*@vm_base;
		background-color: #F6F7F9;
		div{
			width: 100%;
			height: 80*@vm_base;
			border-radius: 16*@vm_base;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 28*@vm_base;
			color: #ffffff;
			background-color: #F77F28;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/demo1/createorder.vue